import React from "react";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import { format } from "date-fns";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import OrderStatus from "../../components/OrderStatus/OrderStatus";
import UserInput from "../../components/UserInput/UserInput";
import axios from "../../utils/Axios/axiosProxy";
import styles from "../UserEntry/UserEntry.module.scss";
import userInputStyle from "../../components/UserInput/UserInput.module.scss";
import { useEffect } from "react";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const TrackOrder = (props) => {
  const [open, setOpen] = React.useState(false);
  const [orderID, setOrderID] = React.useState("");
  const [orderData, setOrderData] = React.useState("");
  const [dialogState, setDialogState] = React.useState(false);
  const ID = props.match.params.id;
  useEffect(() => {
    const getOrderFromDB = (orderID) => {
      let data = { orderID: orderID };
      axios
        .post("/api/order/id", JSON.stringify(data), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("TRACK ORDER RESPONSE: ", response.statusText);
          setOrderData(convertDates(response.data.order));
          setDialogState(true);
        })
        .catch((error) => {
          console.log("TRACK ORDER ERROR: ", error.response.data);
        })
        .catch((error) => console.log("TRACK ORDER CLIENT ERROR:", error));
    };
    if (ID) {
      setOrderID(ID);
      getOrderFromDB(ID);
    }
  }, [ID]);

  const getOrderFromDB = (orderID) => {
    let data = { orderID: orderID };
    axios
      .post("/api/order/id", JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("TRACK ORDER RESPONSE: ", response.statusText);
        setOrderData(convertDates(response.data.order));
        setDialogState(true);
      })
      .catch((error) => {
        console.log("TRACK ORDER ERROR: ", error.response.data);
        setOpen(true);
      })
      .catch((error) => console.log("TRACK ORDER CLIENT ERROR:", error));
  };
  const handleClose = () => {
    setDialogState(false);
  };
  const handleCloseAlert = () => {
    setOpen(false);
  };
  const convertDates = (order) => {
    order.datecreated = format(new Date(order.datecreated), "yyyy-MM-dd");
    for (let i in order.etr) {
      if (order.etr[i].length > 0) {
        order.etr[i] = format(new Date(order.etr[i]), "yyyy-MM-dd");
      }
    }
    return order;
  };
  return (
    <div className={styles.UserEntryContainer}>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
        style={{ width: "100%" }}
      >
        <Alert onClose={handleClose} severity="error" className="AlertWidth">
          Shipment was not found, check the shipment number
        </Alert>
      </Snackbar>
      <div className={styles.UserEntryContent}>
        <h2 className={styles.UserEntryTitle}>Track Shipment</h2>
        <div
          style={{ minHeight: "160px" }}
          className={`${styles.UserEntryInputs} FlexCenter Column`}
        >
          <UserInput
            key="trackorder"
            name="Shipment Number"
            id="orderID"
            className={userInputStyle.RegInput}
            value={orderID}
            onChange={(event) => {
              setOrderID(event.target.value);
            }}
          />

          <div className={styles.UserEntryButton}>
            <Button
              onClick={() => {
                getOrderFromDB(orderID);
              }}
              className="ToreaBay Medium MarginHorizontal"
            >
              Enter
            </Button>
          </div>
        </div>
      </div>
      <Modal
        className="FlexCenter"
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={dialogState}
        onClose={() => handleClose()}
      >
        <OrderStatus content={orderData} />
      </Modal>
    </div>
  );
};
